import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import styled from 'styled-components';
const Container = styled.div `
  display: flex;
  flex-direction: column;

  container-type: inline-size;
`;
const ImageWrapper = styled.div `
  --height: ${fluid(240, 275)};
  @container (min-width: 300px) {
    --height: 230px;
    justify-content: center;
  }

  position: relative;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 16px;

  display: flex;

  [data-cropping-mode='1'] & {
    height: var(--height);
  }

  [data-cropping-mode='0'] & {
    max-height: var(--height);
    min-height: var(--height);
  }
`;
const MainImage = styled.img `
  height: 100%;
  object-position: center center;
  max-height: inherit;
  min-height: inherit;
  margin: auto;
  width: 100%;
  z-index: 1;

  object-fit: contain;
  [data-cropping-mode='0'] &,
  [data-show-blurred-image='false'] & {
    object-fit: cover;
  }

  [data-cropping-mode='1'] & {
    margin: unset;
  }
  padding: 0;

  [data-show-blurred-image='true'] & {
    @container (min-width: 750px) {
      padding: 15px;
      object-fit: contain;
      width: auto;
    }
  }
`;
const BlurredImage = styled.img `
  position: absolute;
  filter: blur(10px);

  width: 100%;
  height: 100%;

  object-fit: cover;
  object-position: center center;

  @container (max-width: 750px) {
    display: none;
  }
`;
const Title = styled.h3 `
  ${fonts.ubuntu.medium};
  color: var(--sectionForegroundColor);
  font-size: ${fluid(25, 30)};
  line-height: ${fluid(25, 38)};
  margin-bottom: 8px;
`;
const Description = styled.p `
  ${fonts.ubuntu.regular};
  color: ${brand.grey.base};
  font-size: ${fluid(16, 18)};
  line-height: ${fluid(20, 24)};
  margin-bottom: 8px;

  [data-theme='dark-blue'] & {
    color: ${brand.primary.white};
  }
`;
const CTAWrapper = styled.div `
  ${ButtonStyles.Container} {
    width: max-content;
    max-width: 100%;

    &[data-variant='inline'] {
      color: ${brand.primary.brightBlue};
      font-size: 18px;
      line-height: 24px;

      ${ButtonStyles.Text} {
        text-decoration: none;
      }
    }
  }
`;
export const ContentCardStyles = {
    Container,
    ImageWrapper,
    BlurredImage,
    MainImage,
    Title,
    Description,
    CTAWrapper,
};
